import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonActionKey, IdentityVerificationFacade, MessageService, SimpleDialogComponent } from 'common';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IDVerseAttempt, KBAData } from '../../customer.model';
import { CustomerIdentityVerificationActivityWidgetAdapter, getInvalidateDialogData, getRefreshDialogData, IDVerseOverallResultLabels, IDVerseRiskLevelLabels, KBAStatusLabels } from './customer-identity-verification-activity-widget.data';
import { ActivityItem } from './customer-identity-verification-activity-widget.model';

@Component({
    selector: 'ifb-customer-identity-verification-activity-widget',
    templateUrl: './customer-identity-verification-activity-widget.component.html',
    styleUrls: ['./customer-identity-verification-activity-widget.component.scss'],
    providers: [CustomerIdentityVerificationActivityWidgetAdapter],
    standalone: false
})
export class IdentityVerificationActivityWidgetComponent implements OnChanges {
  @Input()
  customerId: number;

  @Input()
  kbaData: KBAData;

  @Input()
  idVerseAttempts: IDVerseAttempt[];

  @Input()
  canInvalidate: boolean;

  @Output()
  refreshCustomerData: EventEmitter<void>;

  activityItems: ActivityItem[];
  readonly IDVerseRiskLevelLabels = IDVerseRiskLevelLabels;
  readonly IDVerseOverallResultLabels = IDVerseOverallResultLabels;
  readonly KBAStatusLabels = KBAStatusLabels;

  constructor(
    private readonly adapter: CustomerIdentityVerificationActivityWidgetAdapter,
    private readonly dialog: MatDialog,
    private readonly identityVerificationFacade: IdentityVerificationFacade,
    private readonly messageService: MessageService,
  ) {
    this.refreshCustomerData = new EventEmitter<void>();
   }

  ngOnChanges(): void {
    this.activityItems = this.adapter.adaptActivityListData(this.idVerseAttempts, this.kbaData, this.canInvalidate);
  }

  openReportUrl(reportUrl: string): void {
    if (reportUrl) {
      window.open(reportUrl, '_blank');
    }
  }

  onRefresh(item: ActivityItem): void {
    SimpleDialogComponent.show(this.dialog, getRefreshDialogData()).subscribe((result: string) => {
      if (result === CommonActionKey.Confirm) {
        this.refreshAttempt(item.idVerseAttempt.transactionId).subscribe(() => {
          this.messageService.success('IDVerse attempt results refreshed');
          this.refreshCustomerData.emit();
        });
      }
    });
  }

  onInvalidate(item: ActivityItem): void {
    SimpleDialogComponent.show(this.dialog, getInvalidateDialogData()).subscribe((result: string) => {
      if (result === CommonActionKey.Confirm) {
        this.identityVerificationFacade.invalidate(item.idVerseAttempt.transactionId, this.customerId).pipe(
          switchMap(() => this.refreshAttempt(item.idVerseAttempt.transactionId)),
        ).subscribe(() => {
          this.messageService.success('IDVerse verification invalidated successfully');
          this.refreshCustomerData.emit();
        });
      }
    });
  }

  private refreshAttempt(transactionId: string): Observable<void> {
    return this.identityVerificationFacade.refresh(transactionId, this.customerId);
  }
}
